// @flow
import React, { useContext, useEffect } from 'react';

// Material
import Grid from '@material-ui/core/Grid';
import SwapArrow from '@material-ui/icons/SwapHorizRounded';
import Hidden from '@material-ui/core/Hidden';

// Custom
import { FormGroup } from '../../forms/FormGroup';
import CustomSelect from '../../forms/CustomSelect';
import { CustomFab, SearchFormWrapper } from './components';

// Data
import {
  stationsFromNaritaOptions,
  stationsToNaritaOptions,
  departureTimeOptions,
} from '../../../data/options';

// Context & Actions
import { TrainsContext, actionTypes } from '../../../TrainsContext';

const SearchForm = () => {
  const { state, dispatch } = useContext(TrainsContext);
  const arrowRotation = state.isInboundTrain ? '180' : '0';

  useEffect(() => {
    dispatch({ type: actionTypes.UPDATE_FILTERED_TRAINS });
  }, [
    dispatch,
    state.startingPoint,
    state.endingPoint,
    state.isInboundTrain,
    state.departureTime,
  ]);

  const handleSearchFormChange = (e, type) => {
    dispatch({ type: actionTypes.SET_LOADING, payload: true });

    switch (type) {
      case 'STARTING_POINT':
        dispatch({
          type: actionTypes.UPDATE_STARTING_POINT,
          payload: e.target.value,
        });
        break;
      case 'ENDING_POINT':
        dispatch({
          type: actionTypes.UPDATE_ENDING_POINT,
          payload: e.target.value,
        });
        break;
      case 'DEPARTURE_TIME':
        dispatch({
          type: actionTypes.UPDATE_DEPARTURE_TIME,
          payload: e.target.value,
        });
        break;
      case 'TRAVEL_DIRECTION':
        dispatch({ type: actionTypes.UPDATE_TRAVEL_DIRECTION });
        break;
      default:
        throw new Error('Called action does not exist');
    }

    setTimeout(() => {
      dispatch({ type: actionTypes.SET_LOADING, payload: false });
    }, 350);
  };

  return (
    <SearchFormWrapper>
      <Hidden smUp>
        <CustomFab
          aria-label="Swap to and from stations"
          color="default"
          onClick={e => handleSearchFormChange(e, 'TRAVEL_DIRECTION')}
          style={{ position: 'absolute', top: '-30px', right: '-12px' }}
        >
          <SwapArrow
            color="inherit"
            style={{
              transition: 'transform 200ms ease-out',
              transform: `rotate(${arrowRotation}deg)`,
            }}
          />{' '}
        </CustomFab>
      </Hidden>
      <Grid container spacing={1}>
        <Grid item xs={6} sm={4}>
          <FormGroup>
            <CustomSelect
              label="From"
              defaultValue={state.startingPoint}
              options={
                state.isInboundTrain
                  ? stationsToNaritaOptions
                  : stationsFromNaritaOptions
              }
              onChange={e => handleSearchFormChange(e, 'STARTING_POINT')}
            />
          </FormGroup>
        </Grid>
        <Hidden xsDown>
          <Grid item sm={1} style={{ textAlign: 'center' }}>
            <FormGroup>
              <CustomFab
                aria-label="Swap to and from stations"
                color="default"
                onClick={e => handleSearchFormChange(e, 'TRAVEL_DIRECTION')}
              >
                <SwapArrow
                  color="inherit"
                  style={{
                    transition: 'transform 200ms ease-out',
                    transform: `rotate(${arrowRotation}deg)`,
                  }}
                />{' '}
              </CustomFab>
            </FormGroup>
          </Grid>
        </Hidden>
        <Grid item xs={6} sm={4}>
          <FormGroup>
            <CustomSelect
              label="To"
              defaultValue={state.endingPoint}
              options={
                state.isInboundTrain
                  ? stationsFromNaritaOptions
                  : stationsToNaritaOptions
              }
              onChange={e => handleSearchFormChange(e, 'ENDING_POINT')}
            />
          </FormGroup>
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormGroup>
            <CustomSelect
              label="Departure Time"
              defaultValue={state.departureTime}
              options={departureTimeOptions}
              onChange={e => handleSearchFormChange(e, 'DEPARTURE_TIME')}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </SearchFormWrapper>
  );
};

export default SearchForm;
